import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import scrollIntoView from 'scroll-into-view-if-needed';

import PaginationContext from './PaginationContext';


class Pagination extends PureComponent {

  state = {
    nextChild: null,
    previousChild: null
  };

  componentDidMount() {
    this.setChildrenToScroll();
    window.addEventListener('resize', this.setChildrenToScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setChildrenToScroll);
  }

  setChildrenToScroll = () => {
    const containerScrollLeft = this.scrollContainerReference.current.scrollLeft;
    const containerWidth = this.scrollContainerReference.current.offsetWidth;

    this.setState({
      nextChild: this.chooseNextChild(containerScrollLeft, containerWidth),
      previousChild: this.choosePreviousChild(containerScrollLeft)
    });
  };

  paginationOnScroll = () => {
    window.clearTimeout(this.isScrolling);

    this.isScrolling = setTimeout(() => {
      this.setChildrenToScroll();
    }, 50);
  };

  chooseNextChild = (containerScrollLeft, containerWidth) => {
    const [ nextChild ] = [ ...this.scrollContainerReference.current.children ]
      .filter((child) => this.isNextVisible({ child, containerScrollLeft, containerWidth }));

    return nextChild;
  };

  choosePreviousChild = (containerScrollLeft) => [ ...this.scrollContainerReference.current.children ]
    .filter((child) => this.isPreviousVisible({ child, containerScrollLeft }))
    .pop();

  isNextVisible = ({ child, containerScrollLeft, containerWidth }) => {
    const { offsetLeft, offsetWidth } = child;
    return offsetLeft + offsetWidth > containerScrollLeft + containerWidth;
  };

  isPreviousVisible = ({ child, containerScrollLeft }) => {
    const { offsetLeft } = child;
    return offsetLeft < containerScrollLeft;
  };

  scrollNext = (event) => {
    const containerScrollLeft = this.scrollContainerReference.current.scrollLeft;
    const containerWidth = this.scrollContainerReference.current.offsetWidth;
    const nextChild = this.chooseNextChild(containerScrollLeft, containerWidth);

    this.setState({ nextChild });

    if (!nextChild) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    scrollIntoView(nextChild, { block: 'nearest', inline: 'center', behavior: 'smooth' });
  };

  scrollPrevious = (event) => {
    const containerScrollLeft = this.scrollContainerReference.current.scrollLeft;
    const previousChild = this.choosePreviousChild(containerScrollLeft);

    this.setState({ previousChild });

    if (!previousChild) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    scrollIntoView(previousChild, { block: 'nearest', inline: 'center', behavior: 'smooth' });
  };

  isScrolling;

  scrollContainerReference = React.createRef();

  render() {
    const { scrollContainerReference, scrollNext, scrollPrevious, paginationOnScroll, setChildrenToScroll } = this;
    const { previousChild, nextChild } = this.state;
    const { children } = this.props;


    return (
      <PaginationContext.Provider value={
        {
          nextChild,
          previousChild,
          scrollContainerReference,
          setChildrenToScroll,
          scrollNext,
          scrollPrevious,
          paginationOnScroll
        }
      }
      >
        {children}
      </PaginationContext.Provider>
    );
  }
}


Pagination.propTypes = {
  children: PropTypes.node.isRequired
};


export default Pagination;
